import { FC } from 'react';
import './QuizResultsTeacher.scss';
import images from "../../assets/images";
import { QuizData, Students } from '../../pages/Quiz/Quiz';

type InputProps = {
    selectedQuiz: QuizData | undefined;
}

const QuizResultsTeacher:FC<InputProps> = ({selectedQuiz}) => {

    const baseUrl = process.env.REACT_APP_FRONTEND_URL;
    const { studentProfile } = images;    
    
    return (
        <div className={`${selectedQuiz && selectedQuiz?.students.length > 0 ? "ResultsPageInnerContainer" : "noData" }`}>
            { (selectedQuiz && selectedQuiz?.students.length > 0) ? 
            ( selectedQuiz?.students?.map((value: Students) => {
                return (
                    <div className="ResultsMainContainer">
                        <div className="profileContainer">
                            <div className="profileImage"><img src={value.studentAvatarUrl ? (baseUrl + value.studentAvatarUrl) : studentProfile} alt="student-profile" className='Profile' /></div>
                            <div className='studentName'>{value.studentName}</div>
                        </div>
                        <div className="score">
                            {`${value?.totalScore === 0 ? '0' : String(value?.totalScore).padStart(2, '0')}/${String(selectedQuiz?.questionsCount).padStart(2, '0')}`}
                        </div>
                    </div>
                )
            })) : (
                <div className='noDataFoundStyle'>No data found</div>
            )}
        </div>
    );
}

export default QuizResultsTeacher;